import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/images/loading_new.png'


const _hoisted_1 = { class: "info-container-list" }
const _hoisted_2 = {
  key: 1,
  class: "new-loading wrong-question-loading"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "new-loading-con" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("p", null, "加载中…")
], -1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Cell = _resolveComponent("Cell")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_Cell, {
          key: 0,
          list: _ctx.list,
          fatherKey: _ctx.fatherKey
        }, null, 8, ["list", "fatherKey"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
  ]))
}